import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=59d0066f&scoped=true"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"
import style0 from "./poster.vue?vue&type=style&index=0&id=59d0066f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d0066f",
  null
  
)

export default component.exports